// Find us page in MAT website
// The used map is supported by mapboxgl, https://docs.mapbox.com/mapbox-gl-js/api/

// Defining Global Variables
var map;
var countryCoordinates = [19.105821032211274, 28.27392420689019]; // Assigning a new variable to control the map coordinates when changing / choosing country
const baseUrl = helperUrl + "locator/2";

const countries_fr = {
  azerbaijan: "Azerbaïdjan",
  belgium: "Belgique",
  denmark: "Danemark",
  egypt: "Egypte",
  france: "France",
  germany: "Allemagne",
  hungary: "Hongrie",
  ireland: "Irlande",
  italy: "Italie",
  kuwait: "Koweit",
  lithuania: "Lituanie",
  luxembourg: "Luxembourg",
  morocco: "Maroc",
  netherlands: "Pays-Bas",
  pakistan: "Pakistan",
  poland: "Pologne",
  qatar: "Qatar",
  russia: "Russie",
  "saudi arabia": "Arabie Saoudite",
  slovakia: "Slovaquie",
  "south korea": "Corée du Sud",
  spain: "Espagne",
  taiwan: "Taïwan",
  turkey: "Turquie",
  uae: "Émirats arabes unis",
};

$(document).ready(function () {
  // ready function to load after page finishes

  getData(`${baseUrl}/Stores`); // Getting all the stores to display them in the map

  bindSelect("CountryId", "/Countries");

  $("#CountryId").on("change", function (event) {
    const selectedValue = event.target.value;
    if (selectedValue) {
      bindSelect("CityId", "/CitiesByCountry/" + selectedValue);
      getStoresByCountry(selectedValue);
    }
  });

  $("#CityId").on("change", function (event) {
    const selectedValue = event.target.value;
    if (selectedValue) {
      getStoresByCity(selectedValue);
    }
    $(".select2").select2({
      searchInputPlaceholder: "Recherche ...",
    });
    $(".mdb-select").materialSelect();
  });
});

function getData(url, countryId = 0) {
  // getting the data from mdm server, setting countryId = 0 (default value) thus the map will show our locations in Turkey by default
  $.ajax({
    url: url,
    type: "GET",
    success: function (data) {
      setStore(data, countryId); // Original Code
    },
    error: function (textStatus) {
      console.log(textStatus);
    },
  });
}

function setStore(stores, countryId) {
  // setStore (function given by mapbox API to set the stores on the map)
  // This will let you use the .remove() function later on
  if (!stores.features.length) {
    return;
  }
  if (!("remove" in Element.prototype)) {
    Element.prototype.remove = function () {
      if (this.parentNode) {
        this.parentNode.removeChild(this);
      }
    };
  }
  resetStores();
  mapboxgl.accessToken =
    "pk.eyJ1IjoibWtheWFsLW1kbSIsImEiOiJja3Ywb245NXMwZ2hmMnZwYXg5Y2p3NGlmIn0.C5xu-VjQXZPZvd9bbo5sXg";

  var mapZoom = 3; // Defining mapZoom to control it through the variable

  switch (
    countryId // switch case on by country id, to change the map view ( the ids are taken from the input element for countries in html )
  ) {
    case 0: {
      break;
    } // do nothing when there's no input ( 0 is default)
    case "22": {
      countryCoordinates = [31.1884237, 30.0596185];
      mapZoom = 5;
      break;
    } // Egypt
    case "81": {
      countryCoordinates = [35.4692627, 33.8892846];
      mapZoom = 7;
      break;
    } // Lebanon
    case "80": {
      countryCoordinates = [-7.4082486, 32.330972];
      mapZoom = 5;
      break;
    } // Morocco
    case "83": {
      countryCoordinates = [32.4325085, 15.7504537];
      mapZoom = 5;
      break;
    } // Sudan
    case "82": {
      countryCoordinates = [38.5749086, 34.7017122];
      mapZoom = 5.5;
      break;
    } // Syria
    case "38": {
      countryCoordinates = [30.6857505, 39.0099657];
      mapZoom = 5;
      break;
    } // Turkey
    case "86": {
      countryCoordinates = [47.6423051, 29.2185405];
      mapZoom = 8;
      break;
    } // Kuwait
    case "87": {
      countryCoordinates = [67.9130978, 29.8741062];
      mapZoom = 5;
      break;
    } // Pakistan
    case "88": {
      countryCoordinates = [50.6632628, 25.3445083];
      mapZoom = 8;
      break;
    } // Qatar
    case "89": {
      countryCoordinates = [41.989141, 24.7928967];
      mapZoom = 4;
      break;
    } // Saudi Arabia
    case "90": {
      countryCoordinates = [-7.1697547, 40.0965236];
      mapZoom = 5;
      break;
    } // Spain
    case "36": {
      countryCoordinates = [120.2061284, 23.5256983];
      mapZoom = 5;
      break;
    } // Taiwan
    case "4": {
      countryCoordinates = [1.740985, 46.7601326];
      mapZoom = 4.5;
      break;
    } // France
    case "96": {
      countryCoordinates = [127.024612, 37.5326];
      mapZoom = 5.5;
      break;
    } //Korea
    case "91": {
      countryCoordinates = [55.751244, 55.751244];
      mapZoom = 3;
      break;
    } //Russia
    default: {
      countryCoordinates = [68.2762514, 29.7369275];
      mapZoom = 2;
      break;
    } // Default
  }

  map = new mapboxgl.Map({
    container: "map",
    style: "mapbox://styles/mapbox/light-v10",
    center: countryCoordinates,
    zoom: mapZoom,
    scrollZoom: true,
  });

  stores.features.forEach(function (store, i) {
    store.properties.id = i;
  });

  map.on("load", function (e) {
    /**
     * This is where your '.addLayer()' used to be, instead
     * add only the source without styling a layer
     */
    map.addSource("places", {
      type: "geojson",
      data: stores,
    });

    /**
     * Add all the things to the page:
     * - The location listings on the side of the page
     * - The markers onto the map
     */
    buildLocationList(stores);
    addMarkers(stores);
  });
}

async function bindSelect(selectId, route) {
  $.ajax({
    type: "GET",
    url: baseUrl + route,
    dataType: "json",
    contentType: "application/json",
    success: function (res) {
      removeOption(selectId);
      sortedres = res.sort(function (a, b) {
        var nameA = a.text.toUpperCase(); // ignore upper and lowercase
        var nameB = b.text.toUpperCase(); // ignore upper and lowercase
        if (Shopify?.locale === "fr") {
          nameA =
            countries_fr?.[a.text.toLowerCase()]?.toUpperCase() ||
            a.text.toUpperCase();
          nameB =
            countries_fr?.[b.text.toLowerCase()]?.toUpperCase() ||
            b.text.toUpperCase();
        }
        return nameA.localeCompare(nameB);
      });
      sortedres.forEach((data) => {
        $("#" + selectId).append(appendOption(data));
      });
    },
  });
}

function addMarkers(stores) {
  /* For each feature in the GeoJSON object above: */
  stores.features.forEach(function (marker) {
    /* Create a div element for the marker. */
    var el = document.createElement("div");
    /* Assign a unique `id` to the marker. */
    el.id = "marker-" + marker.properties.id;
    /* Assign the `marker` class to each marker for styling. */
    el.className = "marker";

    /**
     * Create a marker using the div element
     * defined above and add it to the map.
     **/
    new mapboxgl.Marker(el, { offset: [0, -23] })
      .setLngLat(marker.geometry.coordinates)
      .addTo(map);

    /**
     * Listen to the element and when it is clicked, do three things:
     * 1. Fly to the point
     * 2. Close all other popups and display popup for clicked store
     * 3. Highlight listing in sidebar (and remove highlight for all other listings)
     **/
    el.addEventListener("click", function (e) {
      /* Fly to the point */
      flyToStore(marker);
      /* Close all other popups and display popup for clicked store */
      createPopUp(marker);
      /* Highlight listing in sidebar */
      var activeItem = document.getElementsByClassName("active");
      e.stopPropagation();
      if (activeItem[0]) {
        activeItem[0].classList.remove("active");
      }

      var listing = document.getElementById("listing-" + marker.properties.id);
      listing.classList.add("active");
      listing.scrollIntoView({ behavior: "smooth", block: "end" });
    });
  });
}

function buildLocationList(data) {
  data.features
    .sort(function (a, b) {
      return a.properties.property - b.properties.property;
    })
    .forEach(function (store, i) {
      /**
       * Create a shortcut for `store.properties`,
       * which will be used several times below.
       **/
      var prop = store.properties;

      /* Add a new listing section to the sidebar. */
      var listings = document.getElementById("listings");
      var listing = listings.appendChild(document.createElement("div"));
      /* Assign a unique `id` to the listing. */
      listing.id = "listing-" + prop.id;
      /* Assign the `item` class to each listing for styling. */
      listing.className = "item";

      /* Add the link to the individual listing created above. */
      var link = listing.appendChild(document.createElement("a"));
      link.href = "#";
      link.className = "title";
      link.id = "link-" + prop.id;
      link.innerHTML = prop.property.toUpperCase();

      /* Add details to the individual listing. */
      var details = listing.appendChild(document.createElement("div"));
      details.innerHTML = `${prop.crossStreet} <br />${
        prop.postalCode !== null ? prop.postalCode + ", " : ""
      }${prop.city}, ${prop.country}`;

      /**
       * Listen to the element and when it is clicked, do four things:
       * 1. Update the `currentFeature` to the store associated with the clicked link
       * 2. Fly to the point
       * 3. Close all other popups and display popup for clicked store
       * 4. Highlight listing in sidebar (and remove highlight for all other listings)
       **/
      link.addEventListener("click", function (e) {
        for (var i = 0; i < data.features.length; i++) {
          if (this.id === "link-" + data.features[i].properties.id) {
            var clickedListing = data.features[i];
            flyToStore(clickedListing);
            createPopUp(clickedListing);
          }
        }
        var activeItem = document.getElementsByClassName("active");
        if (activeItem[0]) {
          activeItem[0].classList.remove("active");
        }
        this.parentNode.classList.add("active");
      });
    });
}

function flyToStore(currentFeature) {
  // Switching to view the selected store
  map.flyTo({
    center: currentFeature.geometry.coordinates,
    zoom: 15,
  });
}

function createPopUp(currentFeature) {
  var popUps = document.getElementsByClassName("mapboxgl-popup");
  if (popUps[0]) popUps[0].remove();
  var popup = new mapboxgl.Popup({ closeOnClick: false })
    .setLngLat(currentFeature.geometry.coordinates)
    .setHTML(
      '<div class="brand-locator"><img src="https://cdn.shopify.com/s/files/1/0265/7773/1618/files/logo-white-320.png?v=1583849224" alt="Store, locator Majouri" class="img-fluid" /></div>' +
        `<h6>${currentFeature.properties.crossStreet}<br/>${
          currentFeature.properties.postalCode !== null
            ? currentFeature.properties.postalCode + ", "
            : ""
        }${currentFeature.properties.city}</h6>`
    )
    .addTo(map);
}

function resetStores() {
  $("#listings").html("");
}

function getAverageOfCoordinates(stores) {
  let latitudes = [];
  let longitudes = [];
  stores.features.forEach(function (store, i) {
    latitudes.push(store.geometry.coordinates[0]);
    longitudes.push(store.geometry.coordinates[1]);
  });

  const latitudeAvr = getAverageOfArr(latitudes);
  const longitudeAvr = getAverageOfArr(longitudes);
  let coordinatesAvr = [latitudeAvr, longitudeAvr];
  return coordinatesAvr;
}

function getAverageOfArr(arr) {
  let sum = 0;
  for (let i = 0; i < arr.length; i++) {
    sum += arr[i];
  }
  return sum / arr.length;
}

function getStoresByCountry(countryId) {
  const url = `${baseUrl}/StoresByCountry/${countryId}`;
  getData(url, countryId);
}

function getStoresByCity(cityId) {
  const url = `${baseUrl}/StoresByCity/${cityId}`;
  getData(url);
}

function appendOption(data) {
  // [START] M. Gamal Code to translate Countries

  let countryLabel = data.text;
  try {
    if (Shopify?.locale === "fr") {
      let countryKey = countryLabel.toLowerCase();
      countryLabel = countries_fr?.[countryKey] || countryLabel;
    }
  } catch (err) {
    console.log("Failed to translate Country:\nError: ", err);
  }

  const capitalizeAllCountries = ["uae", "usa", "uk"];

  if (capitalizeAllCountries.includes(countryLabel.toLowerCase())) {
    // capitalize all
    countryLabel = countryLabel.toUpperCase();
  } else {
    // capitalize the first letter
    countryLabel =
      countryLabel[0].toUpperCase() + countryLabel.slice(1).toLowerCase();
  }

  // [END] M. Gamal Code to translate Countries
  return `<option value="${data.value}">${countryLabel}</option>`;
}

function removeOption(selectId) {
  const select = $("#" + selectId);
  select.children("option:not(:first)").remove();
}
